import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'

import { LocationWorkingHoursComponent } from './location-working-hours.component'

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
  ],
  exports: [
    LocationWorkingHoursComponent,
  ],
  declarations: [
    LocationWorkingHoursComponent,
  ],
  providers: [],
})
export class LocationWorkingHoursModule { }
